import * as React from 'react';
import './formButtonWrapper.module.scss';

type Props = {
    children: any;
    className?: string;
    styleName?: string;
};

export const FormButtonWrapper = ({ children, className }: Props) => {
    return (
        <div styleName="form-button-wrapper" className={className}>
            {children}
        </div>
    );
};
